<template>
  <!--
  Events:
  => option-activated: { option }
  => option-deactivated: { option }
  => option-updated: { option }
  -->
  <div
    :class="{
      'ml-pom__container': true,
      'ml-pom--editable': editable,
      'ml-pom--selected': active,
      'ml-pom--syncing': syncing
    }">
    <div class="ml-pom__side-panel">
      <div class="ml-pom__check-icon mb-1 mr-2" @click="raiseEvent">
        <div class="ml-pom__check-icon__center"></div>
      </div>
      <div class="ml-pom__toggles">
        <button v-on:click="toggleEditability" class="ml-pom__toggle ml-btn ml-btn--white">
          <i class="fas fa-pencil-alt"></i>
        </button>
      </div>
    </div>

    <div class="ml-pom__main-panel" @click="raiseEvent">
      <div class="ml-pom__title">{{ title }}</div>
      <img class="ml-pom__img" :alt="title" :src="imageSource">
      <div class="ml-pom__mode text-muted">{{ paymentMode.paymentModeName }}</div>
    </div>

    <!-- Edit payment options -->
    <modal action="Save"
           :name="`payment-option#${paymentOption.countryPayerClientID}`"
           :no-icon="false"
           :title="`Configure <b>${ title }</b>`"
           @cancel="cancelEdit"
           @save="saveEdit">
      <div class="form-group">
        <label class="control-label" for="role">Payment Mode</label>
        <select id="role" name="role" class="form-control" v-model="selectedPayerMode">
          <option v-for="(mode, index) in paymentOption.paymentModes" :value="parseInt(mode.payerModeID)" :key="`${index}@${mode.payerModeID}`">
            {{ mode.paymentModeName }}
          </option>
        </select>
      </div>
    </modal>
    <!-- End of the edit payment options -->
  </div>
</template>

<script>
  import _ from 'lodash'
  import Buefy from 'buefy'
  import Modal from '@/components/Modal'

  const logInfo = !!(process.env.NODE_ENV !== 'production')

  export default {
    components: {
      Modal,
      'b-checkbox': Buefy.Checkbox,
    },
    computed: {
      active () {
        return this.selected
      },
      editable: {
        get () {
          return this.internalState.editing
        },

        set (value) {
          this.internalState.editing = value
        }
      },
      paymentMode: {
        get () {
          if (
            this.internalState.payerModeID !== undefined &&
            this.internalState.payerModeID !== 0 &&
            this.internalState.payerModeID !== null
          ) {
            logInfo && console.log('A predefined mode exists for this option =>', this.paymentOption.payerModeID)
            return this.paymentOption.paymentModes[_.findIndex(this.paymentOption.paymentModes, ['payerModeID', _.toString(this.internalState.payerModeID)])]
          }

          return this.paymentOption.paymentModes[0]
        },
        set (value) {
          this.internalState.payerModeID = value
          this.$emit('option-updated', _.merge(this.paymentOption, {payerModeID: this.paymentMode.payerModeID}))
        }
      },
      syncing () {
        return this.status === 2
      }
    },
    data () {
      return {
        mode: 'view',
        internalState: {
          active: false,
          editing: false,
          payerModeID: undefined
        },
        selectedPayerMode: undefined
      }
    },
    methods: {
      cancelEdit () {
        this.$modal.hide(`payment-option#${this.paymentOption.countryPayerClientID}`)
      },
      raiseEvent () {
        if (this.paymentOption.optionEnabled) {
          return this.$emit('option-deactivated', _.merge(this.paymentOption, {payerModeID: this.paymentMode.payerModeID}))
        }

        return this.$emit('option-activated', _.merge(this.paymentOption, {payerModeID: this.paymentMode.payerModeID}))
      },
      saveEdit () {
        this.paymentMode = this.selectedPayerMode
        this.$modal.hide(`payment-option#${this.paymentOption.countryPayerClientID}`)
      },
      toggleEditability () {
        this.$modal.show(`payment-option#${this.paymentOption.countryPayerClientID}`)
      }
    },
    name: 'PaymentOptionManager',
    mounted () {
      this.internalState.active = this.selected
      this.internalState.payerModeID = this.paymentOption.payerModeID
      this.selectedPayerMode = this.internalState.payerModeID
    },
    props: {
      imageSource: {
        required: true,
        type: String
      },
      paymentOption: {
        required: true
      },
      selected: {
        type: Boolean,
        default: false
      },
      status: {
        default: 2
      },
      title: {
        required: true,
        type: String
      }
    }
  }
</script>

<style lang="scss">
@import "../styles/theme";

.ml-pom__container{
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  height: 70px;
  width: 120px;

  &.ml-pom--selected {
    .ml-pom__toggles {
      display: block;
    }

    .ml-pom__mode {
      display: block;
    }

    .ml-pom__check-icon {
      border-color: $primary-color;
    }
    .ml-pom__check-icon__center {
      background-color: $primary-color;
      border-color: $primary-color;
    }
  }
  &.ml-pom--selected.ml-pom--syncing {
    .ml-pom__check-icon {
      border-color: $orange !important;
    }
    .ml-pom__check-icon__center {
      background-color: $orange !important;
      border-color: $orange !important;
    }
  }

  &.ml-pom--editable {
    .ml-pom__toggle.ml-pom__toggle--edits {
      display: block;
    }

    .ml-pom__toggle:not(.ml-pom__toggle--edits) {
      display: none;
    }
  }
}

.ml-pom__side-panel {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.ml-pom__toggles {
  display: none;
  margin-top: -.5rem 0;
}

.ml-pom__toggle {
  height: 25px;
  width: 25px;

  align-items: center;
  display: flex;
  justify-content: center;

  border-radius: 50% !important;
  margin: .5rem 0 !important;
  padding: 0;
  outline: none;

  svg {
    width: .7rem !important;
  }

  &.ml-pom__toggle--edits {
    display: none;
  }
}

.ml-pom__check-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid $border-color;
  border-radius: 50%;
  height: 26px;
  width: 26px;

  .ml-pom__check-icon__center {
    background-color: inherit;
    border: 1px solid $border-color;
    border-radius: 50%;
    height: 10px;
    width: 10px;
  }
}

.ml-pom__main-panel {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.ml-pom__title {
  font-size: 12px;
  font-weight: 600;
}

.ml-pom__img {
  width: 70px;

  margin: 10px 0;
}

.ml-pom__mode {
  display: none;

  font-size: 10px;
}

// Overwrite buefy
label.b-checkbox {
  height: 25px !important;
  width: 25px !important;

  span.check {
    height: 100% !important;
    width: 100% !important;
  }
}

.b-checkbox.checkbox input[type=checkbox]:checked + .check {
  border-color: #18cbf8;
  background-size: 75%;
  background-color: #18cbf8;
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentOptionManager.vue